import { DefectStatusEnum } from '../../enum/defect-status.enum';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class InspectionOutcomeData {
  InspectionOutcomeId: string;
  AppliesToDefectStatus: DefectStatusEnum;
  IsSafe: boolean;
  RequireNotify: boolean;
  RequireInstruct: boolean;
  GroupTitle: string;
  Code: string;
  Title: string;
  Subtitle: string;
  ReportText: string;
  RequireFurtherInformation: boolean;
  SortOrder: number;
  IconName: string;
  ReplacedWithId: string;
  Deleted: boolean;
  IsDefault: boolean;
}


